import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { AdsChartResponse, AdsPeriod } from '@brand24-original/llm-types';
import { AdsFilters, getAdsChart } from '../../services/ads/AdsService';
import { GET_ADS_CHART } from '../../query/ads/keys';

export const useGetAdsChart = (
  projectId: number | null,
  period: AdsPeriod | null,
  from: Date | null,
  to: Date | null,
  filters: AdsFilters,
  enabled = true
) => {
  const queryEnabled = !!projectId && !!period && !!from && !!to && enabled;

  const { data, isLoading, isError, refetch } = useQuery<AdsChartResponse>({
    queryKey: [GET_ADS_CHART, projectId, period, from, to, filters.models, filters.promptIds, filters.advertisers],
    queryFn: () => getAdsChart(projectId!, period!, from!, to!, filters),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
    placeholderData: keepPreviousData,
  });

  return {
    data,
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
